import {
   VisitDocumentTemplateMarkAsFavoriteCommand,
   VisitDocumentTemplateType,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import {
   dispatchSnackbarPositiveEvent,
   HeartIcon,
   Link,
   LinkSize,
   LinkVariant,
   Tooltip,
} from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { documentTemplateActionTranslationKeys } from '../../../../../../translations';

type DocumentTemplateMarkAsFavoriteIconProps = {
   readonly type: VisitDocumentTemplateType;
   readonly printTemplateId: number | undefined;
   readonly onMarkAsFavorite: VoidFunction;
};

export const DocumentTemplateMarkAsFavoriteIcon = (props: DocumentTemplateMarkAsFavoriteIconProps): JSX.Element => {
   const { executeAsync: markAsFavorite } = useCqrsCommand<void, void>(
      () => {
         const command = new VisitDocumentTemplateMarkAsFavoriteCommand();
         command.type = props.type;
         command.printTemplateId = Choice.withUseDefaultIfNull(props.printTemplateId ?? null);
         return command;
      },
      {
         onSuccess: () => {
            props.onMarkAsFavorite();
            dispatchSnackbarPositiveEvent(
               documentTemplateActionTranslationKeys.form.table.options.favorite.markAsFavorite.successMessage
            );
         },
      }
   );

   return (
      <Tooltip
         testId={'markAsFavorite'}
         content={documentTemplateActionTranslationKeys.form.table.options.favorite.markAsFavorite.tooltipMessage}
      >
         <Link
            testId={'markAsFavorite'}
            variant={LinkVariant.PRIMARY_LIGHTEST}
            size={LinkSize.BIG}
            icon={<HeartIcon />}
            onClick={async () => markAsFavorite()}
         />
      </Tooltip>
   );
};
